module.exports = __webpack_public_path__ + "img/userEquity5.7e2381ba.png";